import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Linkedin } from 'lucide-react';
const team = [{
  name: 'Pratik Gadia',
  role: 'Founder & CEO',
  bio: 'Serial entrepreneur with deep roots in the textile industry. Visionary behind The Yarn Bazaar.',
  image: 'https://cdn.magicpatterns.com/uploads/wZTcg5mLtUhwZGKcBj9hn3/Pratik_Gadia.jpg',
  linkedin: 'https://www.linkedin.com/in/pratikgadia/',
  initials: 'PG'
}, {
  name: 'Vishal Darak',
  role: 'Co-Founder & CTO',
  bio: "Tech leader building the digital infrastructure that powers India's textile supply chain.",
  image: 'https://cdn.magicpatterns.com/uploads/1bV12aDogHABa9TvLz81xG/Vishal_Darak.jpg',
  linkedin: 'https://www.linkedin.com/in/vishal-darak/',
  initials: 'VD'
}];
export function Team() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  return <section ref={ref} className="py-24 bg-[#FAFAF8]" data-id="element-588">
      <div className="max-w-6xl mx-auto px-5 lg:px-8" data-id="element-589">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-590">
          <p className="text-xs font-inter font-semibold text-[#E8500A] tracking-[0.18em] uppercase mb-4" data-id="element-591">
            Our Team
          </p>
          <h2 className="font-jakarta text-4xl md:text-5xl font-extrabold text-[#0F0E0C] leading-tight" data-id="element-592">
            The people behind the platform
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-2xl mx-auto" data-id="element-593">
          {team.map((member, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 24,
          filter: 'blur(4px)'
        }} animate={isInView ? {
          opacity: 1,
          y: 0,
          filter: 'blur(0px)'
        } : {}} transition={{
          duration: 0.6,
          delay: i * 0.15
        }} className="bg-white rounded-2xl border border-[#E8E4DC] overflow-hidden hover:border-[#D4CFC5] hover:shadow-lg hover:shadow-black/5 transition-all duration-300 card-lift" data-id="element-594">
              <div className="aspect-square overflow-hidden bg-[#F5F4F0]" data-id="element-595">
                <img src={member.image} alt={member.name} className="w-full h-full object-cover object-top" data-id="element-596" />
              </div>
              <div className="p-6" data-id="element-597">
                <div className="flex items-start justify-between gap-3" data-id="element-598">
                  <div data-id="element-599">
                    <h3 className="font-jakarta font-extrabold text-[#0F0E0C] text-lg leading-tight" data-id="element-600">
                      {member.name}
                    </h3>
                    <p className="text-sm text-[#E8500A] font-inter font-semibold mt-0.5" data-id="element-601">
                      {member.role}
                    </p>
                  </div>
                  <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="flex-shrink-0 w-8 h-8 rounded-lg bg-[#0A66C2]/10 flex items-center justify-center hover:bg-[#0A66C2] hover:text-white transition-all duration-200 text-[#0A66C2]" data-id="element-602">
                    <Linkedin className="w-4 h-4" data-id="element-603" />
                  </a>
                </div>
                <p className="text-sm text-[#5C5A55] font-inter leading-relaxed mt-3" data-id="element-604">
                  {member.bio}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}